import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../../components/Analytics/VisibilityPixel/VisibilityPixel';
import CardTitle from '../../../components/Elements/CardTitle/CardTitle';
import LanderHeader from '../../../components/Groups/LanderHeader/LanderHeader';
import RenderGroup from '../../../components/Groups/RenderGroup/RenderGroup';
import Button from '../../../components/Input/Button/Button';
import PageNav from '../../../components/JobComponents/Pagination/PageNav/PageNav';
import CommonCardShell from '../../../components/Layout/CommonCardShell/CommonCardShell';
/* COMPONENTS */
import Layout from '../../../components/Layout/Layout';
import RightRailContent from '../../../components/Layout/ThreeColumnGridLayout/RightRailContent/RightRailContent';
import ThreeColumnLayout from '../../../components/Layout/ThreeColumnLayout/ThreeColumnLayout';
import LeftRailContent from '../../../components/LeftRailLayout/LeftRailContent/LeftRailContent';
/* STYLESHEETS */
import './AllGroups.scss';

export default class AllGroups extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * array of all fgb groups sent back
         */
        groups: PropTypes.array.isRequired,
        /**
         * object of pagination
         */
        pagination: PropTypes.shape({
            /**
             * string of previous page url
             */
            prevUrl: PropTypes.string,
            /**
             * string of next page url
             */
            nextUrl: PropTypes.string,
        }).isRequired,
        /**
         * number of FGB users
         */
        numberOfUsers: PropTypes.number.isRequired,
    };

    renderFGBGroups = () => {
        return (
            <CommonCardShell className="fgb-groups">
                <CardTitle className="all-groups-heading" headerTag="h1">
                    Groups on Fairygodboss
                </CardTitle>
                <ul>{this.props.groups.map(this.renderGroup)}</ul>
                {this.renderPageNavigation()}
            </CommonCardShell>
        );
    };

    renderPageNavigation = () => {
        return (
            <PageNav
                prevUrl={this.props.pagination.prevUrl}
                nextUrl={this.props.pagination.nextUrl}
            />
        );
    };

    renderGroup = (group, index) => {
        return (
            <RenderGroup group={group} key={`group-${index}`} index={index} />
        );
    };

    renderButtons = () => {
        return (
            <div className="cta-buttons">
                <a href="/groups/create">
                    <Button
                        onClick={this.handleMetrics('create-group')}
                        value="Create a group"
                        type="secondary-blue-gray"
                    />
                </a>
                <a href="/groups/search">
                    <Button
                        onClick={this.handleMetrics('search-groups')}
                        value="Search groups"
                        type="purple-medium-white"
                    />
                </a>
            </div>
        );
    };

    handleMetrics = (type) => () => {
        if (type === 'create-group') {
            return EmitMetric({
                misc_event_type: 'create-group-all-groups-click',
                misc_event_count: 1,
            });
        } else if (type === 'search-groups') {
            return EmitMetric({
                misc_event_type: 'search-groups-all-groups-click',
                misc_event_count: 1,
            });
        }
    };

    renderRightRailContent = () => {
        if (!Object.keys(this.props.PAGE_PROPS.session).length) {
            return <RightRailContent contents={['sponsoredCompany']} />;
        }

        return (
            <RightRailContent
                contents={['recommendedGroups', 'recommendedConnections']}
            />
        );
    };

    render() {
        return (
            <div className="page-Groups-AllGroups">
                <Layout PAGE_PROPS={this.props.PAGE_PROPS}>
                    <ThreeColumnLayout>
                        <ThreeColumnLayout.LeftRail>
                            <LeftRailContent />
                        </ThreeColumnLayout.LeftRail>

                        <ThreeColumnLayout.MainContent>
                            <CommonCardShell>
                                <LanderHeader
                                    numberOfUsers={this.props.numberOfUsers}
                                />
                                {this.renderButtons()}
                            </CommonCardShell>
                            {this.renderFGBGroups()}
                        </ThreeColumnLayout.MainContent>

                        <ThreeColumnLayout.RightRail>
                            {this.renderRightRailContent()}
                        </ThreeColumnLayout.RightRail>
                    </ThreeColumnLayout>
                </Layout>
            </div>
        );
    }
}
